module.exports = __webpack_public_path__ + "img/dzhxm.f9eefd08.png";